<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Devoluciones</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <b-row>
            <b-col sm="2">
              <b-form-group
                :label="crearLabel('Fecha Programada de Pago', 'fecpago', 'datosFormulario')"
                label-for="fecpago">
                <b-form-select 
                  :options="valFechas"  
                  v-model="datosFormulario.fecpago"
                >
                </b-form-select>
                
                <span class="error-validacion-campo">
                  {{ mensajeValidacionCampo.fecpago }}
                </span>
              </b-form-group>
            </b-col>  
            <b-col sm="2">
              <b-form-group 
                :label="crearLabel('Código Asegurado', 'codasegurado', 'datosFormulario')"
                label-for="codasegurado">
                <b-form-input
                  id="codasegurado"
                  type="text"
                  placeholder=""
                  v-model="datosFormulario.codasegurado"
                  @change="buscarAsegurado">
                </b-form-input>
                <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.codasegurado }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group 
                :label="crearLabel('Asegurado', 'desasegurado', 'datosFormulario')"
                label-for="desasegurado">
                <b-form-input
                  id="desasegurado"
                  type="text"
                  placeholder=""
                  v-model="datosFormulario.desasegurado"
                  :disabled="true">
                </b-form-input>
              
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="2">
            </b-col>  
            <b-col sm="2">
              <b-form-group 
                :label="crearLabel('Código Beneficiario', 'codbeneficiario', 'datosFormulario')"
                label-for="codbeneficiario">
                <b-form-input
                  id="codbeneficiario"
                  type="text"
                  placeholder=""
                  v-model="datosFormulario.codbeneficiario"
                  
                  @change="buscarBeneficiario">
                </b-form-input>
                <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.codbeneficiario }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group 
                :label="crearLabel('Beneficiario', 'desbeneficiario', 'datosFormulario')"
                label-for="desbeneficiario">
                <b-form-input
                  id="desbeneficiario"
                  type="text"
                  placeholder=""
                  v-model="datosFormulario.desbeneficiario"
                  :disabled="true">
                </b-form-input>
              
              </b-form-group>
            </b-col>
          </b-row>

          <div slot="footer">
            <div class="form-actions">
              <el-row>
                <el-col>
                  <b-button variant="primary" @click="buscar">
                    <i class="fa fa-search"></i> Consultar
                  </b-button>
                  <b-button variant="primary" @click="pre_insertar">
                    <i class="fa fa-eraser"></i> Limpiar
                  </b-button>
                  <b-button variant="primary" @click="descargarExcel">
                    <i class="fa fa-file-excel-o"></i> Exportar
                  </b-button>
                  
                  <b-button v-if="this.multipleSelection.length != 0" variant="success" @click="modalDevolver = true" style="color: #ffffff; margin-left: 10px;">
                    <i class="fa fa-save"></i> Devolver
                  </b-button>
                  <b-button v-if="this.multipleSelection.length != 0" variant="warning" @click="modalRecalcular = true" style="color: #ffffff; margin-left: 10px;">
                    <i class="fa fa-refresh"></i> Recalcular
                  </b-button>
                  <b-button v-if="this.multipleSelection.length != 0"   variant="danger" @click="modalNoDevolver = true" style="color: #ffffff; margin-left: 10px;">
                  
                    <i class="fa fa-times"></i> No Devolver
                  </b-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Devoluciones - Casos que se pueden pagar</strong>
          </div>
          <b-row>
            <b-col lg="6"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProcesoSP"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filtersSp[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable1"
                  :data="data"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filtersSp"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  @selection-change="handleSelectionChange">
                >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    :formatter="formatter"
                    sortable="custom"
                    
                    name="table"
                    class="table-responsive"
                  >
                  
                 <template slot-scope="scope">
                    <div v-if="title.prop == 'SLQRECEPTOR'">  
                        <el-button type="text" v-if="scope.row.CANTBENEFI > 1" @click="detalleBeneficiarios(scope.row.SLQSINIESTRO)">Beneficiarios ({{scope.row.SLQRECEPTOR}})</el-button>   
                        <p v-else >{{scope.row.SLQRECEPTOR}}</p>
                    </div>
                    <p v-else>{{scope.row[title.prop]}}</p>
                  </template>
                  </el-table-column>

                  <el-table-column label="Revisión GS" min-width="100px" align="center">
                  <template slot-scope="scope">
                    <el-tooltip
                        v-for="button in customButtonsForRow(scope.row)"
                        :key="button.id"
                        :content="button.tooltip"
                        placement="top">
                        <el-button
                          type="text"
                          @click="button.handler"
                        >
                          <i v-bind:class="button.icon"></i>
                          {{ button.name }}
                        </el-button>
                    </el-tooltip>
                  </template>
                  </el-table-column>



                  <el-table-column type="selection" width="35" reserve-selection><!-- reserve-selection -->
                  </el-table-column>
                </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Devoluciones - Casos que no se pueden pagar</strong>
          </div>
          <b-row>
            <b-col lg="6"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filtersNp[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable2"
                  :data="data2"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filtersNp"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table">
                >
                  <el-table-column
                    v-for="title in titles2"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    sortable="custom"
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  >
                  <template slot-scope="scope">
                    <div v-if="title.prop == 'SLQRECEPTOR'">  
                        <el-button type="text" v-if="scope.row.CANTBENEFI > 1" @click="detalleBeneficiarios(scope.row.SLQSINIESTRO)">Beneficiarios ({{scope.row.SLQRECEPTOR}})</el-button>   
                        <p v-else >{{scope.row.SLQRECEPTOR}}</p>
                    </div>
                    <p v-else>{{scope.row[title.prop]}}</p>
                  </template>
                  
                  </el-table-column>

                </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    
    <!-- Devolver-->
    <b-modal
      title="Devolver"
      cancel-title="Cancelar"
      ok-title="Continuar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalDevolver"
      @ok="devolver"
      @cancel="modalDevolver = false"
    >
      Usted devolverá {{ this.multipleSelection.length }} casos con fecha {{ this.datosFormulario.fecpago }}, ¿desea continuar?
    </b-modal>

    <!-- Recalcular-->
    <b-modal
      title="Recalcular"
      cancel-title="Cancelar"
      ok-title="Recalcular"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalRecalcular"
      @ok="recalcular"
      @cancel="modalRecalcular = false"
    >
      Todos los siniestros seleccionados estarán disponible en la pantalla Recupero por Devolver para ser Recalculados.
    </b-modal>

    <!-- No Devolver-->
    <b-modal
      size="lg"
      ok-only
      title="No Devolver"
      cancel-title="Cancelar"
      ok-title="No devolver"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalNoDevolver"
      @ok="nodevolver"
      @cancel="modalNoDevolver = false"
    >
      <b-row>
        <b-col lg="12">
          <!-- <b-row>
            <b-col>
              <label for="input-small">Seleccione el Motivo</label>
                <b-form-group>
                  <b-form-radio-group
                    size="sm"
                    v-model="datosFormulario.opcnodevolver"
                    :options="opcnodevolver"
                  ></b-form-radio-group>
                </b-form-group>

            </b-col> 
          </b-row> -->

          <b-row >
            <b-col> 
              <label for="input-small">Todos los siniestros seleccionados serán devueltos a la pantalla Recupero por Devolver.</label>
              <b-form-textarea
                id="textarea"
                v-model="datosFormulario.otrosmotivos"
                placeholder="Ingrese algún motivo para no devolver"
                rows="2"
                max-rows="2"
              ></b-form-textarea>
            </b-col>   
          </b-row>  
        </b-col>
      </b-row>   
      <!-- Todos los siniestros seleccionados seran devueltos a la pantalla Recupero por Devolver. -->
    </b-modal>

  
    <!-- Detalle Beneficiarios -->
    <b-modal
      size="lg"
      ok-only
      title="Beneficiarios"
      cancel-title="Cancelar"
      ok-title="Cerrar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalBeneficiarios"
      @ok="modalBeneficiarios = false"
      @cancel="modalBeneficiarios = false"
    >
      <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable3"
                  :data="dataBeneficiarios"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                >
                  <el-table-column
                    v-for="title in titlesBeneficiarios"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>
                </data-tables>
              </div>
            </b-col>
          </b-row>
    </b-modal>

    <!-- Resumen del Caso -->
  <b-modal
      size="lg"
      hide-footer
      title="Calcular Devolucion"
      cancel-title="Cancelar"
      ok-title="Devolver"
      ok-variant="success"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalCalDevolucion"
      @ok="devolver"
      @cancel="modalCalDevolucion = false"
    >
      <b-row>
        <b-col lg="12">
          <b-tabs lazy>
            <b-tab title="Calculo de Devolución">
              
              <b-row>
                <b-col sm="6">
                  <label for="input-small">Estado del siniestro</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="desestado" size="sm" placeholder="Estado del Siniestro" class="mt-1" v-model="datosCalcDevolucion.desestado" :disabled="true"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small">Fecha estimada de configuracion</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="festconfig" size="sm" placeholder="Fecha estimada de configuracion" class="mt-1" v-model="datosCalcDevolucion.festconfig" :disabled="true" :formatter= "formatter" ></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small">Tratamiento del recupero</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="tratamiento" size="sm" placeholder="Tratamiento del recupero" class="mt-1" v-model="datosCalcDevolucion.tratamiento" :disabled="true"></b-form-input>
                </b-col>
              </b-row>
              
              <b-row>
                <b-col sm="6">
                  <label for="input-small">Reglas</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="reglas" size="sm" placeholder="Reglas" class="mt-1" v-model="datosCalcDevolucion.reglas" :disabled="true"></b-form-input>
                </b-col>
              </b-row>
              
              <b-row>
                <b-col sm="6">
                  <label for="input-small">Moneda de la póliza</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="sndmoneda" size="sm" placeholder="Moneda de la póliza" class="mt-1" v-model="datosCalcDevolucion.sndmoneda" :disabled="true"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small">Moneda de la devolución</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="slqmoneda" size="sm" placeholder="Moneda de la devolución" class="mt-1" v-model="datosCalcDevolucion.slqmoneda" :disabled="true"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small">Coaseguro (%)</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="sndcoaseguro" size="sm" placeholder="Coaseguro (%)" class="mt-1" v-model="datosCalcDevolucion.sndcoaseguro" :disabled="true" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small" >Parte Cubierta (%)</label>
                </b-col>
                <b-col sm="6">
                  <b-form-input id="partcubierta" size="sm" placeholder="Parte Cubierta (%)" class="mt-1" v-model="datosCalcDevolucion.partcubierta" :disabled="true" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>
              
              <b-row>
                <b-col sm="6">
                  <label for="input-small" >Recepción Informe</label>
                </b-col>
                <b-col sm="6">
                  <b-input-group>
                  
                  <b-form-input id="ilqfrecepcion" size="sm" placeholder="Recepción Informe" class="mt-1" v-model="datosCalcDevolucion.ilqfrecepcion" :disabled="true"></b-form-input>
                  <b-input-group-append>
                    <b-button v-if="datosCalcDevolucion.informe != undefined" size="sm" block  variant="info" @click="buscarInformeCorreo(datosCalcDevolucion.informe)" style="color: #ffffff;" class="mt-1" v-b-tooltip.hover title="Ver Informe"> <i class="fa fa-file-pdf-o"> </i></b-button>
                    <b-button v-if="datosCalcDevolucion.correo != undefined" size="sm" block  variant="info" @click="buscarInformeCorreo(datosCalcDevolucion.correo)" style="color: #ffffff;" class="mt-1" v-b-tooltip.hover title="Ver Correo"> <i class="fa fa-envelope-o"> </i></b-button>
                  </b-input-group-append>
                </b-input-group>

                </b-col> 
              </b-row>
            
              <br>
              <!-- <label for="input-small">--------------------------------------------------------------------------------------------------------------------------------------------------------</label> -->
              <b-row>
                <b-col sm="6">
                  
                </b-col>
                <b-col sm="3" align="center">
                  <b><label for="input-small">Moneda póliza</label></b>
                </b-col>
                <b-col sm="3" align="center">
                  <b><label for="input-small">Pesos</label></b>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <label for="input-small" class="mt-1">Recuperos del período</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtorecmoneda" size="sm" align="right" placeholder="Moneda póliza" v-model="datosCalcDevolucion.mtorecmoneda" :disabled="true" style="text-align:right"></b-form-input>    
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtorecpesos" size="sm" align="right" placeholder="Pesos" v-model="datosCalcDevolucion.mtorecpesos" :disabled="true" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small" class="mt-1">Gastos (AB+CO+PE) del periodo</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtogastosmoneda" size="sm" placeholder="Moneda póliza" class="mt-1" v-model="datosCalcDevolucion.mtogastosmoneda" :disabled="true" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtogastospesos" size="sm" placeholder="Pesos" class="mt-1" v-model="datosCalcDevolucion.mtogastospesos" :disabled="true" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <b><label for="input-small" class="mt-1">Monto a devolver en este proceso</label></b>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtodevmoneda" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.mtodevmoneda" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtodevpesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.mtodevpesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small" class="mt-1">Monto impago total</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtoimpagomoneda" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.mtoimpagomoneda" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtoimpagopesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.mtoimpagopesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small" class="mt-1">Total pagos al beneficiario</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="totpagosmoneda" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.totpagosmoneda" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="totpagospesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.totpagospesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label for="input-small" class="mt-1">Saldo actual por devolver</label>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="saldoactualmoneda" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.saldoactualmoneda" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="saldoactualpesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.saldoactualpesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <b><label for="input-small" class="mt-1">Monto a devolver es menor al saldo</label></b>
                </b-col>
                <b-col sm="3" >
                  <b-form-input id="mtodevok" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.mtodevok" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="mtodevokpesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.mtodevokpesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>
              
              <b-row>
                <b-col sm="6">
                  <label for="input-small" class="mt-1">Reliquidación devolver recuperos</label>
                </b-col>
                <b-col sm="3" >
                  <b-form-input id="reliqmoneda" size="sm" placeholder="Moneda póliza" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.reliqmoneda" style="text-align:right"></b-form-input>
                </b-col>
                <b-col sm="3">
                  <b-form-input id="reliqpesos" size="sm" placeholder="Pesos" class="mt-1" :disabled="true" v-model="datosCalcDevolucion.reliqpesos" style="text-align:right"></b-form-input>
                </b-col>
              </b-row>
              <br>
              <br> 

            <div v-if="datosCalcDevolucion.devOtroMonto != 0">
              <b-row>  
                <b-col lg="4">
                </b-col>
                <b-col lg="4" class="pb-10"> 
                </b-col>
                <b-col sm="4">
                  <b-button size="sm" block  variant="info" @click="accionBoton('otroMonto')" style="color: #ffffff;">Devolver otro monto</b-button>
                  <br>
                    <b-row>
                      <b-col sm="12">
                         <b-input-group>
                          <b-form-input id="devMonOtroMonto" size="sm" placeholder="devMonOtroMonto" :disabled="true" v-model="datosCalcDevolucion.devMonOtroMonto"></b-form-input>
                          <b-input-group-append>
                            <b-form-input id="devOtroMonto" size="sm" placeholder="devOtroMonto" :disabled="true" v-model="datosCalcDevolucion.devOtroMonto" style="text-align:right"></b-form-input>
                          </b-input-group-append>
                        </b-input-group> 
                      </b-col>
                    </b-row>  
                </b-col>
              </b-row>
            </div>
            
            </b-tab>

            <b-tab title="Beneficiarios">
              <br/>
              <b-row>
                <el-table 
                  ref="refTable3"
                  :data="dataBeneficiarios"
                  style="width: 100%"
                  border
                  max-height="400px"
                  :row-class-name="tableRowClassName">

                  <el-table-column
                    v-for="title in titlesBeneficiarios"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>
                </el-table>
              </b-row>
              <br>

            </b-tab>  
          </b-tabs>
          
        </b-col>
      </b-row>
      <b-footer class="seccion-final">
        <b-button class="mt-2" variant="secondary" @click="modalCalDevolucion = false" style="color: #ffffff; ">Cerrar</b-button> 
        <b-button class="mt-2" variant="success" @click="devolver" style="color: #ffffff; margin-left: 10px;"><i class="fa fa-save"></i> Devolver</b-button> 
        
      
      </b-footer>
    </b-modal>
    

  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiDevolucion from "@/components/services/apiDevolucion";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import download from "downloadjs";
import Multiselect from "vue-multiselect";

import XLSX from "xlsx";

export default {
  name: "Devoluciones",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch,
  },
  data: function () {
    return {
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715",
      },

      data: [],
      data2: [],
      dataBeneficiarios: [],
      nombreexcel: "Devoluciones",
      titles: [
        {
          prop: "SNDASEGURADO",
          label: "Razón social Asegurado",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "SLQRECEPTOR",
          label: "Razón social Beneficiario",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "SLQSINIESTRO",
          label: "N° de Siniestro",
          align: "left",
          minwidth: "150",
        },
        {
          prop: "SNDEJECUTIVO",
          label: "Ejecutivo",
          align: "left",
          minwidth: "120",
        },
        {
          prop: "SNDSUJRIESGO",
          label: "Razón social Deudor",
          align: "left",
          minwidth: "300",
        },
        // {
        //   prop: "SLQMONEDA",
        //   label: "Moneda Poliza",
        //   align: "center",
        //   minwidth: "120",
        // },
        // {
        //   prop: "SLQMONTOMONEDA",
        //   label: "Monto a Devolver",
        //   align: "right",
        //   minwidth: "160",
        // },
        {
          prop: "SLQMONEDADEV",
          label: "Mon. de la devolución",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "SLQMONTODEV",
          label: "Mto. a devolver",
          align: "right",
          minwidth: "130",
        },
        // {
        //   prop: "SLQMTODEVMONPOL",
        //   label: "Mto. a devolver Mon. Pol",
        //   align: "right",
        //   minwidth: "140",
        // },
        {
          prop: "SLQFECPAGO",
          label: "Fecha de Pago",
          align: "center",
          minwidth: "120",
        }
      ],
      
      titles2: [
        {
          prop: "SNDASEGURADO",
          label: "Razón social Asegurado",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "SLQRECEPTOR",
          label: "Razón social Beneficiario",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "SLQSINIESTRO",
          label: "N° de Siniestro",
          align: "left",
          minwidth: "150",
        },
        {
          prop: "SNDEJECUTIVO",
          label: "Ejecutivo",
          align: "left",
          minwidth: "120",
        },
        {
          prop: "SNDSUJRIESGO",
          label: "Razón social Deudor",
          align: "left",
          minwidth: "300",
        },
        // {
        //   prop: "SLQMONEDA",
        //   label: "Moneda",
        //   align: "center",
        //   minwidth: "120",
        // },
        // {
        //   prop: "SLQMONTOMONEDA",
        //   label: "Monto a Devolver",
        //   align: "right",
        //   minwidth: "160",
        // },
        {
          prop: "SLQMONEDADEV",
          label: "Mon. de la devolución",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "SLQMONTODEV",
          label: "Mto. a devolver",
          align: "right",
          minwidth: "130",
        },
        // {
        //   prop: "SLQMTODEVMONPOL",
        //   label: "Mto. a devolver Mon. Pol",
        //   align: "right",
        //   minwidth: "140",
        // },
        {
          prop: "SLQFECPAGO",
          label: "Fecha de Pago",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "MOTIVO",
          label: "Motivo",
          align: "left",
          minwidth: "250",
        }
      ],
      filtersSp: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              if (prop === 'Fecha Est. Config'){
                let elDate = new Date(row["Fecha Est. Config"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }
            })
            
          }
        }
      ],

      filtersNp: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              if (prop === 'Fecha Est. Config'){
                let elDate = new Date(row["Fecha Est. Config"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }
            })
            
          }
        }
      ],

      titlesBeneficiarios: [
        {
          prop: "SBCCODBENEF",
          label: "Codigo",
          align: "center",
          minwidth: "80",
        },
        {
          prop: "SBCIDNACBENEF",
          label: "Id Nación",
          align: "right",
          minwidth: "100",
        },
        {
          prop: "SBCNOMBENEF",
          label: "Razón Social",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "SBCMONEDA",
          label: "Moneda",
          align: "center",
          minwidth: "80",
        },
        {
          prop: "SBCMONTO",
          label: "Monto",
          align: "right",
          minwidth: "100",
        },
        {
          prop: "SBCPORCENTAJE",
          label: "Porcentaje",
          align: "center",
          minwidth: "100",
        }
      ],

      datosFormulario: {
        fecpago: "",
        codasegurado: "",
        codbeneficiario: "",
        otrosmotivos:""
        
      },

      datosCalcDevolucion: {
        desestado: "",
        festconfig: "",
        tratamiento: "",
        reglas: "",
        sndmoneda:"",
        slqmoneda:"",
        sndcoaseguro: "",
        partcubierta: "",
        mtodevmoneda: "",
        mtodevpesos: "",
        mtoimpagomoneda: "",
        mtoimpagopesos: "",
        totpagosmoneda: "",
        totpagospesos: "",
        saldoactualmoneda: "",
        saldoactualpesos: "",
        mtodevok: "",
        mtodevokpesos: "",
        ilqfrecepcion: "",
        informe: "",
        correo: "",
        devolucion:"",
        reliqmoneda: "",
        reliqpesos:"",
        mtogastospesos: "",
        mtogastosmoneda: "",
        mtorecmoneda: "",
        mtorecpesos: "",
        siniestro:"",
        slqdevolucion:"",
        estado:"",
        devMonOtroMonto:"",
        devOtroMonto:""
      },


      opcnodevolver: [],

      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},
      valFechas: [],
      multipleSelection: [],
      modalDevolver: false,
      modalRecalcular: false,
      modalNoDevolver: false,
      modalBeneficiarios: false,
      modalCalDevolucion: false,
      
      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 200,
        rowKey: "SLQSINIESTRO"
      },
    };
  },
  components: {
    Datepicker,
    Multiselect,
  },
  methods: {
    customButtonsForRow(row) {
          var botones = new Array();
          
          if (row.INFORME)
          {
            var obj = new Object();
            obj.tooltip = "Informe Liquidación";
            obj.id = 1;
            obj.name="";
            obj.icon = "fa fa-file-pdf-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                window.open(row.INFORME, '_blank');
            }
            botones.push(obj);
          }

          if (row.CORREO)
          {
            var obj = new Object();
            obj.tooltip = "Correo";
            obj.id = 2;
            obj.name="";
            obj.icon = "fa fa-envelope-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                window.open(row.CORREO, '_self');
            }
            botones.push(obj);
          }

          var obj = new Object();
            obj.tooltip = "Detalle de la Devolución";
            obj.id = 1;
            obj.name="";
            obj.icon = "fa fa-pencil-square-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                this.recuperar_devolucion(row);
            }
            botones.push(obj);
          
          
          return botones;

    },

    getDate(date) {
      let elDate = new Date(date)
      return elDate.getDate() + '/' + (elDate.getMonth() + 1) + '/' + elDate.getFullYear();   
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.refTable1.$children[0].toggleRowSelection(row);
        });
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
      
    },

    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },

    cambiarFechas() {
      if (this.datosFormulario.selected == "A") {
        this.mostrarFechas = false;
      } else {
        this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
      n = String(n).replace(/\D/g, "");
      return n === "" ? n : Number(n).toLocaleString();
    },

    totales(param) {
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }

        const values = data.map((item) => Number(item[column.property]));

        if (!values.every((value) => isNaN(value))) {
          sums[index] = this.$numeral(
            values.reduce((prev, curr) => {
              const value = Number(curr);

              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          ).format();
          /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },

    tableRowClassName({ row }) {
      if(row.marca == "1"){
            return 'warning-row';
        }
        else{
            return 'estiloFilaTabla';
        }
      
    },

    exportarExcel() {
      this.$nextTick(function () {
        var tabla = document.getElementById("tableExcel");
        var data = XLSX.utils.table_to_sheet(tabla);
        const workbook = XLSX.utils.book_new();
        const filename = "Export";
        XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}.xlsx`);
      });
    },

    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.value = null;
      this.datosFormulario.desasegurado = "";
      this.datosFormulario.desbeneficiario = "";

      return apiDevolucion
        .pre_insercion_devolucion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          
          //Bloqueo usuario no valido
          // if (response.data.args_out.usuarioval == "s") {
          //   this.tieneAcceso = true;
          // } else {
          //   this.tieneAcceso = false;
          // }

          var lista_data = response.data.res;
          for (var i = 0; i < lista_data.length; i++) {
            this.datosFormulario.fecpago = this.convierteFecha(lista_data[i]["fecpago"]);
            this.datosFormulario.codasegurado = lista_data[i]["codasegurado"]=='0'? '' : lista_data[i]["codasegurado"];
            this.datosFormulario.codbeneficiario = lista_data[i]["codbeneficiario"]=='0'? '' : lista_data[i]["codbeneficiario"];
          }
          
          //Carga lista de Fechas
          var tiposFecha = new Array();
          var lista_tipos_fecha = response.data.fechas;
          for(var i = 0; i < lista_tipos_fecha.length; i++){
              var obj = new Object();
              obj.value = this.convierteFecha(lista_tipos_fecha[i]["slqfecpago"]);
              obj.text = this.convierteFecha(lista_tipos_fecha[i]["slqfecpago"]);
              tiposFecha.push(obj);

          }
          this.valFechas = tiposFecha;

       
          //Carga lista de Opcion no Devolver
          // if (response.data.opcnodevolver != undefined){
            
            var tiposOpcNoDevolver = new Array();
            var lista_tiposOpcNoDevolver = response.data.opcnodevolver;
            for(var i = 0; i < lista_tiposOpcNoDevolver.length; i++){
                var obj = new Object();
                obj.value = lista_tiposOpcNoDevolver[i]["codigo"];
                obj.text = lista_tiposOpcNoDevolver[i]["descripcion"];
                tiposOpcNoDevolver.push(obj);
            }
            this.opcnodevolver = tiposOpcNoDevolver;
          // }
          
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();
      this.data = [];
      this.data2 = [];
      return apiDevolucion
        .devolucion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.fecpago,
          this.datosFormulario.codasegurado == ''? '0' : this.datosFormulario.codasegurado, 
          this.datosFormulario.codbeneficiario == ''? '0' : this.datosFormulario.codbeneficiario 

        )
        .then((response) => {
          
          this.data = response.data.casospagar;
          this.data2 = response.data.casosnopagar;
          this.pagina = this.paginaAnterior;

          if (this.data != null) {
            this.exportar = true;
          } else {
            this.exportar = false;
          }

          this.$Progress.finish();
        })

        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    recuperar_devolucion(row){
      console.log(row);
      this.$Progress.start();
           apiDevolucion
           .recuperar_resumen(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            row.SLQSINIESTRO,
            row.SLQDEVOLUCION
          )
          
           .then(response => {
             this.dataCalDevolucion = response.data.res1;  
             console.log(response.data.res1);
             this.modalCalDevolucion = true;
            
            if (response.data.res1.length > 0) {
                this.mostrarOpciones = false;
                this.opcionesOtroMonto = false;
                this.dataCalDevolucion.slqdevolucion = response.data.res1[0].SLQDEVOLUCION;
                this.datosCalcDevolucion.desestado = response.data.res1[0].SNDESTADO;
                this.datosCalcDevolucion.festconfig = this.convierteFecha(response.data.res1[0].SNDFESTCONFIG);
                this.datosCalcDevolucion.tratamiento = response.data.res1[0].TRATAMIENTO;
                this.datosCalcDevolucion.reglas = response.data.res1[0].REGLAS;
                this.datosCalcDevolucion.sndmoneda = response.data.res1[0].SNDMONEDA;
                this.datosCalcDevolucion.slqmoneda = response.data.res1[0].SLQMONEDA;
                // this.$numeral(row[column.property]).format("0,0.00")
                this.datosCalcDevolucion.sndcoaseguro = response.data.res1[0].SNDCOASEGURO
                this.datosCalcDevolucion.partcubierta = response.data.res1[0].PARTCUBIERTA
                this.datosCalcDevolucion.tratamiento = response.data.res1[0].TRATAMIENTO;
                this.datosCalcDevolucion.ilqfrecepcion = this.convierteFecha(response.data.res1[0].ILQFRECEPCION);
                
                this.datosCalcDevolucion.informe = response.data.res1[0].INFORME;
                this.datosCalcDevolucion.correo = response.data.res1[0].CORREO;

                this.datosCalcDevolucion.mtodevmoneda = this.$numeral(response.data.res1[0].MTODEVMONEDA).format("0,0.00");
                this.datosCalcDevolucion.mtodevpesos = this.$numeral(response.data.res1[0].MTODEVPESOS).format("0,0");

                this.datosCalcDevolucion.mtorecmoneda =  this.$numeral(response.data.res1[0].MTORECMONEDA).format("0,0.00");
                this.datosCalcDevolucion.mtorecpesos = this.$numeral(response.data.res1[0].MTORECPESOS).format("0,0");

                this.datosCalcDevolucion.mtogastosmoneda = this.$numeral(response.data.res1[0].MTOGASTOSMONEDA).format("0,0.00");
                this.datosCalcDevolucion.mtogastospesos = this.$numeral(response.data.res1[0].MTOGASTOSPESOS).format("0,0");
                
                this.datosCalcDevolucion.mtoimpagomoneda = this.$numeral(response.data.res1[0].MTOIMPAGOMONEDA).format("0,0.00");
                this.datosCalcDevolucion.mtoimpagopesos = this.$numeral(response.data.res1[0].MTOIMPAGOPESOS).format("0,0");

                this.datosCalcDevolucion.totpagosmoneda = this.$numeral(response.data.res1[0].TOTPAGOSMONEDA).format("0,0.00");
                this.datosCalcDevolucion.totpagospesos = this.$numeral(response.data.res1[0].TOTPAGOSPESOS).format("0,0");

                this.datosCalcDevolucion.saldoactualmoneda = this.$numeral(response.data.res1[0].SALDOACTUALMONEDA).format("0,0.00");
                this.datosCalcDevolucion.saldoactualpesos = this.$numeral(response.data.res1[0].SALDOACTUALPESOS).format("0,0");

                this.datosCalcDevolucion.mtodevok = response.data.res1[0].MTODEVOK;
                this.datosCalcDevolucion.mtodevokpesos = response.data.res1[0].MTODEVOKPESOS;

                this.datosCalcDevolucion.reliqmoneda = this.$numeral(response.data.res1[0].RELIQMONEDA).format("0,0.00");
                this.datosCalcDevolucion.reliqpesos = this.$numeral(response.data.res1[0].RELIQPESOS).format("0,0");

                this.datosCalcDevolucion.devMonOtroMonto = response.data.res1[0].DEVMONOTROMONTO;
                this.datosCalcDevolucion.devOtroMonto = this.$numeral(response.data.res1[0].DEVOTROMONTO).format("0,0");

            }

            //  this.detalleBeneficiarios(row.SINIESTRO, false);
             this.$Progress.finish();

          })
          .catch(error => {
            this.modalCalDevolucion = false;
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    },

    formatter(row, column) {
      if ((column.property == "Fecha Est. Config" || column.property == "Fecha Recep. Inf. Liq." || 
           column.property == "Fecha Pago Nómina") 
          && row[column.property]) {
        return this.configurarFechaLat(
          this.convierteFecha(row[column.property])
        );
      } else if ((column.property == "SBCMONTO") && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } else {
        return row[column.property];
      }
    },

    

    descargarExcel: function () {
      var cuerpo = "";
      var columnas = this.titles;
      var columnas2 = this.titles2;

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      
      cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
      cuerpo += "<td colspan=" +
        columnas.length +
        " class=xl689618 width=698 style='width:526pt;" +
        xl689618 +
        "'>Devoluciones para el " + this.datosFormulario.fecpago + "</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 style='height:21.0pt;"+xl159618+"'></td>\n";
      cuerpo += "<td colspan=" +
        columnas.length +
        " class=xl689618 style='border-right:.5pt solid black;" +
        xl689618 +
        "' >Devoluciones - Casos que se pueden pagar</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      for (var key in this.data) {
        if(this.data[key]["SNDASEGURADO"] == undefined){
          this.data[key]["SNDASEGURADO"] = "";
        }
        if(this.data[key]["SLQRECEPTOR"] == undefined){
          this.data[key]["SLQRECEPTOR"] = "";
        }
        if(this.data[key]["SLQSINIESTRO"] == undefined){
          this.data[key]["SLQSINIESTRO"] = "";
        }
        if(this.data[key]["SNDEJECUTIVO"] == undefined){
          this.data[key]["SNDEJECUTIVO"] = "";
        }
        if(this.data[key]["SNDSUJRIESGO"] == undefined){
          this.data[key]["SNDSUJRIESGO"] = "";
        }
        // if(this.data[key]["SLQMONEDA"] == undefined){
        //   this.data[key]["SLQMONEDA"] = "";
        // }
        // if(this.data[key]["SLQMONTOMONEDA"] == undefined){
        //   this.data[key]["SLQMONTOMONEDA"] = "";
        // }
        if(this.data[key]["SLQFECPAGO"] == undefined){
          this.data[key]["SLQFECPAGO"] = "";
        }
        if (this.data[key]["SLQMONEDADEV"] == undefined){
          this.data[key]["SLQMONEDADEV"] = "";
        }
        if (this.data[key]["SLQMONTODEV"] == undefined){
          this.data[key]["SLQMONTODEV"] = "";
        }
        if (this.data[key]["SLQMTODEVMONPOL"] == undefined){
          this.data[key]["SLQMTODEVMONPOL"] = "";
        }
        
        
        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["SNDASEGURADO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["SLQRECEPTOR"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["SLQSINIESTRO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["SNDEJECUTIVO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["SNDSUJRIESGO"] + "</td>\n";
        // cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["SLQMONEDA"] + "</td>\n";
        // cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["SLQMONTOMONEDA"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["SLQMONEDADEV"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["SLQMONTODEV"]).format("0,0.00") + "</td>\n";
        // cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["SLQMONTOMONEDA"]).format("0,0.00") + "</td>\n";
        // cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["SLQFECPAGO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >" + this.data[key]["SLQFECPAGO"] + "</td>\n";
        cuerpo += "</tr>\n";
      }



      cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 style='height:21.0pt;"+xl159618+"'></td>\n";
      cuerpo +=
        "<td colspan=" +
        columnas2.length +
        " class=xl689618 style='border-right:.5pt solid black;" +
        xl689618 +
        "' >Devoluciones - Casos que no se pueden pagar</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas2.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas2[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";
      
      //Data bloque 2
      for (var key in this.data2) {
        if(this.data2[key]["SNDASEGURADO"] == undefined){
          this.data2[key]["SNDASEGURADO"] = "";
        }
        if(this.data2[key]["SLQRECEPTOR"] == undefined){
          this.data2[key]["SLQRECEPTOR"] = "";
        }
        if(this.data2[key]["SLQSINIESTRO"] == undefined){
          this.data2[key]["SLQSINIESTRO"] = "";
        }
        if(this.data2[key]["SNDEJECUTIVO"] == undefined){
          this.data2[key]["SNDEJECUTIVO"] = "";
        }
        if(this.data2[key]["SNDSUJRIESGO"] == undefined){
          this.data2[key]["SNDSUJRIESGO"] = "";
        }
        if(this.data2[key]["SLQMONEDA"] == undefined){
          this.data2[key]["SLQMONEDA"] = "";
        }
        if(this.data2[key]["SLQMONTOMONEDA"] == undefined){
          this.data2[key]["SLQMONTOMONEDA"] = "";
        }
        if(this.data2[key]["SLQFECPAGO"] == undefined){
          this.data2[key]["SLQFECPAGO"] = "";
        }
        if(this.data2[key]["MOTIVO"] == undefined){
          this.data2[key]["MOTIVO"] = "";
        }
        
        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["SNDASEGURADO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["SLQRECEPTOR"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["SLQSINIESTRO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["SNDEJECUTIVO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["SNDSUJRIESGO"] + "</td>\n";
        // cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["SLQMONEDA"] + "</td>\n";
        // cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data2[key]["SLQMONTOMONEDA"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["SLQMONEDADEV"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["SLQMONTODEV"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["SLQFECPAGO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["MOTIVO"] + "</td>\n";
        cuerpo += "</tr>\n";
      }

      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export: async function (data, filename) {
      if (typeof this.beforeFinish === "function") await this.beforeFinish();
      download(data, filename, "application/vnd.ms-excel");
    },

    convierteFecha(fechaEntrada) {
      if (fechaEntrada != undefined && fechaEntrada.length != 0) {
        var fecha = new Date(fechaEntrada);

        var dia = ("0" + fecha.getUTCDate()).slice(-2);
        var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2);
        var año = fecha.getUTCFullYear();

        fecha = dia + "-" + mes + "-" + año;

        return fecha;
        
      } else {
        return fechaEntrada;
      }
    },
    
    buscarAsegurado(){
      this.$Progress.start();
      return apiDevolucion
        .nombre_asegurado(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.codasegurado 
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();

          if (response.data.res.length > 0) {
            this.datosFormulario.desasegurado = response.data.res[0].nombre_asegurado;
          } else {
            this.datosFormulario.codasegurado = '';
            this.datosFormulario.desasegurado = '';
          }
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscarBeneficiario(){
      this.$Progress.start();
      return apiDevolucion
        .nombre_beneficiario(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.codbeneficiario 
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();

          if (response.data.res.length > 0) {
            this.datosFormulario.desbeneficiario = response.data.res[0].nombre_beneficiario;
          } else {
            this.datosFormulario.codbeneficiario = '';
            this.datosFormulario.desbeneficiario = '';
          }
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    devolver(){
      
      this.$Progress.start();

      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.SLQFOLIO);
      var marcados = new Array();
      
      for (var index = 0; index < this.multipleSelection.length; ++index) {
          
          if (names.includes(this.multipleSelection[index]["SLQFOLIO"])){
              marcados.push(this.multipleSelection[index]);
          }
      }
      
      var foliosMarcados = "";
      var index = 0;

      for (index = 0; index < marcados.length; ++index) {
        foliosMarcados += marcados[index]["SLQFOLIO"] + ',';
      }

      
      if (foliosMarcados != ""){
        foliosMarcados = foliosMarcados.slice(0, -1)
        apiDevolucion
          .devolver(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            foliosMarcados,
            this.datosFormulario.fecpago
          )
          .then(response => {
            this.modalCalDevolucion = false;
            this.$Progress.finish();
            this.crearNotificacion(
                "Devolver",
                response.data.festado.resultado.mensaje,//"Se han indemnizado todos los siniestros seleccionados.",
                "success"
              );
            this.mail_devolver();
            this.buscar();
            
          }
          
          )
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }

      // this.$Progress.finish();
    },

    recalcular(){
      this.$Progress.start();

      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.SLQDEVOLUCION);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["SLQDEVOLUCION"])){
            marcados.push(this.multipleSelection[index]);

          }
      }
      /* -- */

      var NroDevolucionMarcados = "";
      var index = 0;
      
      for (index = 0; index < marcados.length; ++index) {
        NroDevolucionMarcados += marcados[index]["SLQDEVOLUCION"] + ',';
      }
      
      
      if (NroDevolucionMarcados != ""){
        NroDevolucionMarcados = NroDevolucionMarcados.slice(0, -1)
        apiDevolucion
          .recalcular(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            NroDevolucionMarcados
          )
          .then(response => {
            this.$Progress.finish();
            this.crearNotificacion(
                "Recalcular",
                "Todos los siniestros seleccionados estaran disponible en la pantalla Recupero por Devolver para ser Recalculados.",
                "success"
              );
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
    },

    nodevolver(){
      this.$Progress.start();
      
      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.SLQDEVOLUCION);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["SLQDEVOLUCION"])){
            marcados.push(this.multipleSelection[index]);
          }
      }
      /* -- */


      var NroDevolucionMarcados = "";
      var index = 0;
      
      for (index = 0; index < marcados.length; ++index) {
        NroDevolucionMarcados += marcados[index]["SLQDEVOLUCION"] + ',';
      }
      
      if (NroDevolucionMarcados != ""){
        NroDevolucionMarcados = NroDevolucionMarcados.slice(0, -1)
        apiDevolucion
          .nodevolver(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            NroDevolucionMarcados,
            this.datosFormulario.otrosmotivos
          )
          .then(response => {
            this.$Progress.finish();
            this.crearNotificacion(
                "No Devolver",
                "Se reversara todo el proceso de devolución",
                "success"
              );
            this.datosFormulario.otrosmotivos="";  
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
    },

    mail_devolver(){
      this.$Progress.start();

      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.SLQDEVOLUCION);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["SLQDEVOLUCION"])){
            marcados.push(this.multipleSelection[index]);

          }
      }
      /* -- */

      var NroDevolucionMarcados = "";
      var index = 0;
      
      for (index = 0; index < marcados.length; ++index) {
        NroDevolucionMarcados += marcados[index]["SLQDEVOLUCION"] + ',';
      }
      
      
      if (NroDevolucionMarcados != ""){
        NroDevolucionMarcados = NroDevolucionMarcados.slice(0, -1)
        apiDevolucion
          .mail_devolver(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            NroDevolucionMarcados
          )
          .then(response => {
            this.$Progress.finish();
            this.crearNotificacion(
                "Email de Aviso de Devolución",
                "Se generaron los email de Aviso de Devolución de los registros seleccionados",
                "success"
              );
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
    },
  
    detalleBeneficiarios(siniestro){
      apiDevolucion
          .recuperar_beneficiario(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestro
          )
          .then(response => {
            this.$Progress.finish();
            this.dataBeneficiarios = response.data.res1;
            this.modalBeneficiarios = true;
          })
          .catch(error => {
            this.modalBeneficiarios = false;
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    }
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
  },

  watch: {
    pagina: function (nuevo, anterior) {
      this.paginaAnterior = anterior;
    },

    data: function() {
      this.$nextTick(function() {
        this.$refs.refTable1.$children[0].clearSelection();
        var lista = this.data;
        var index = 0;
        for (index = 0; index < lista.length; ++index) {
            this.toggleSelection([lista[index]]);
        }
      })
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.seccion-final {
  display: flex;
  justify-content: flex-end;
}

.multiselect__tag {
  background: #20a8d8 !important;
}
.multiselect__option--highlight:after {
  background: #20a8d8 !important;
}

.multiselect__option--highlight {
  background: #20a8d8 !important;
}
.multiselect__tags {
  border-radius: 0px !important;
  min-height: 70px !important;
}
</style>